import { CardStyleInterpolators, HeaderStyleInterpolators } from "@react-navigation/stack";
import {
    createPlatformStackNavigator,
    PlatformStackScreenOptions,
} from "../createPlatformStackNavigator";
import { useTheme } from "../../hooks/use-theme";
import { Platform } from "react-native";
import React from "react";
import UserTodosScreen from "../../screens/user/UserTodos";
import { useI18n } from "../../hooks/i18n-hooks";
import Icon from "../../components/Icon";
import { useCardStyleInterpolator } from "../../hooks/use-card-style-interpolator";
import MissionDetailsScreen from "../../screens/user/MissionDetails";
import InvitationScreen from "../../screens/Invitation";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import ScreenHeader from "../../screens/user/ScreenHeader";

export type UserActivitiesTabParamList = {
    TodoList: { filters?: string };
    Invitation: { invitationId: string };
    MissionDetails: { missionId: string };
};

const Stack = createPlatformStackNavigator<UserActivitiesTabParamList>();

const UserActivitiesNavigation = () => {
    const theme = useTheme();
    const i18n = useI18n();
    const insets = useSafeAreaInsets();

    const cardStyleInterpolator = useCardStyleInterpolator();

    return (
        // On native the default-header screen (TodoList) shows the system back button; the custom
        // back icon, header interpolator and card interpolator (dim backdrop, no-animation-on-web)
        // are JS-stack-only and kept on web. Native uses its default push animation.
        <Stack.Navigator
            screenOptions={{
                headerStyle: {
                    backgroundColor: theme.colors.background,
                },
                headerBackButtonDisplayMode: "minimal",
                headerTitleAlign: "center",
                gestureEnabled: true,
                headerShadowVisible: false,
            }}
            webScreenOptions={{
                headerMode: "screen",
                headerStatusBarHeight: insets.top,
                headerBackImage: () => (
                    <Icon
                        name="back"
                        size={28}
                        style={{ marginLeft: Platform.OS === "ios" ? 10 : 0, marginRight: 5 }}
                    />
                ),
                cardStyleInterpolator,
                headerStyleInterpolator: HeaderStyleInterpolators.forUIKit,
            }}
        >
            <Stack.Screen
                name="TodoList"
                component={UserTodosScreen}
                options={{
                    headerShown: true,
                    title: i18n.t("screens.user.todos.title"),
                    gestureEnabled: true,
                }}
            />
            <Stack.Screen
                name="Invitation"
                component={InvitationScreen}
                // Native presents a real modal; web keeps the JS-stack vertical slide-up.
                options={
                    {
                        header: ({ navigation }) => {
                            return (
                                <ScreenHeader
                                    useSmallLabel
                                    onLeftAction={() => navigation.goBack()}
                                    leftIcon="close"
                                    label={i18n.t("screens.invitation.title")}
                                />
                            );
                        },
                        headerShown: true,
                        ...(Platform.OS === "web"
                            ? { cardStyleInterpolator: CardStyleInterpolators.forVerticalIOS }
                            : { presentation: "modal" }),
                    } as PlatformStackScreenOptions
                }
            />
            <Stack.Screen
                name="MissionDetails"
                component={MissionDetailsScreen}
                options={{
                    headerShown: false,
                    title: i18n.t("mission.nav_title"),
                    gestureEnabled: true,
                }}
            />
        </Stack.Navigator>
    );
};

export default UserActivitiesNavigation;
